module.exports = __webpack_public_path__ + "static/media/app-banner.a42b18f9.png";